import { render } from "./NotificationItem.vue?vue&type=template&id=78f1bcc9&scoped=true&ts=true"
import script from "./NotificationItem.vue?vue&type=script&lang=ts"
export * from "./NotificationItem.vue?vue&type=script&lang=ts"

import "./NotificationItem.vue?vue&type=style&index=0&id=78f1bcc9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f1bcc9"]])

export default __exports__